import { useInstanceKey } from "app/area/favourite/favourite-context";
import { useActionCreators } from 'app/area/case-report/case-listing/hooks';
import { useEffect } from "react";
import { selectSelectedReport, selectWorkingDefenitionIncludedDomains } from "app/area/favourite/selectors";
import { useSelector } from "react-redux";
import { selectAdditionalIncludedFields, selectIncludedFields } from "app/area/case-report/case-listing/selectors";

export function useCaseListingDrawerEvents() {
  const instanceKey = useInstanceKey();
  const selectedReport = useSelector(selectSelectedReport(instanceKey));
  const { loadDefaultIncludedFields, setIncludedFields, loadAdditionalIncludedFields, updateDefaultIncludedFields } = useActionCreators();
  const defaultFields = useSelector(selectIncludedFields(instanceKey));
  const additionalIncludedFields = useSelector(selectAdditionalIncludedFields(instanceKey));

  const fetchAdditionalIncludedFields = (query: string) => {
    if (selectedReport?.v) {
      loadAdditionalIncludedFields(selectedReport.v, query);
    }
  };

  useEffect(() => {
    loadDefaultIncludedFields(selectedReport?.v);
  }, [loadDefaultIncludedFields, selectedReport.v]);

  return {
    defaultFields,
    setIncludedFields,
    fetchAdditionalIncludedFields,
    additionalIncludedFields,
    updateDefaultIncludedFields
  };
}

export function useWorkingDefinitionSelectedIncludedFields() {
  const instanceKey = useInstanceKey();
  return useSelector(selectWorkingDefenitionIncludedDomains(instanceKey));
}
